export default __webpack_public_path__ + "static/media/resume.30188a0d.pdf";